// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1cdiG","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Hwcd"};